import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ids", "items", "styleSheet"];
import React from 'react';
import PropTypes from 'prop-types';
import { compose, setDisplayName, setPropTypes, withProps } from 'recompose';
import omitProps from '@hocs/omit-props';
import wrapOverridableComponent from '@bubble-ui/hoc-wrap-overridable-component';
import View from '@bubble-ui/primitive-view';
import Text from '@bubble-ui/primitive-text';
import { withDesignVersion } from '@bubble-ui/provider-design-version';
import { withDesignContext } from '@klarna/designtokens';
import SpacerVertical from '@bubble-ui/atom-spacer-vertical';
import withDeprecationWarning from '@bubble-ui/hoc-with-deprecation-warning';
import { defaultDesignTokens } from './defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
var OfferBreakdown = _ref => {
  var {
      ids,
      items,
      styleSheet: {
        containerStyle,
        itemContainerStyle,
        itemTextStyle,
        detailTextStyle
      }
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(View, _extends({
    id: ids.root,
    style: containerStyle
  }, props), items.map((_ref2, index) => {
    var {
      item,
      detail
    } = _ref2;
    return /*#__PURE__*/React.createElement(View, {
      key: index
    }, /*#__PURE__*/React.createElement(View, {
      id: ids.item(index),
      style: itemContainerStyle
    }, /*#__PURE__*/React.createElement(Text, {
      id: ids.itemText,
      style: itemTextStyle
    }, item), /*#__PURE__*/React.createElement(Text, {
      id: ids.detailText,
      style: detailTextStyle(Boolean(detail.isStrong))
    }, detail.text)), items.length - 1 !== index && /*#__PURE__*/React.createElement(SpacerVertical, {
      extraSmall: true
    }));
  }));
};

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default compose(setDisplayName('OfferBreakdown'), setPropTypes({
  items: PropTypes.arrayOf(PropTypes.shape({
    item: PropTypes.string,
    detail: PropTypes.shape({
      text: PropTypes.string,
      isStrong: PropTypes.bool
    })
  }))
}), withDesignVersion, withDesignContext(defaultDesignTokens),
// ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
// Keep passing all props to the style sheet, even if we don't use them ourselves
wrapOverridableComponent('OfferBreakdown', getDefaultStyleSheet), withProps(getIds), omitProps('id', 'designVersion', 'designContext'), withDeprecationWarning({
  name: 'OfferBreakdown',
  removalDate: 'v6.0.0'
}))(OfferBreakdown);
//# sourceMappingURL=index.js.map